import { bootstrapApplication } from '@angular/platform-browser';
import { spartacusAppConfig } from './app/features/new-marketplace/src/app/app.config.spartacus';
import { App } from './app/features/new-marketplace/src/app/app';

bootstrapApplication(App, spartacusAppConfig).catch((err) => console.error(err));
